import React from 'react'
import { BHTagList } from '@bh/components'

type Props = {
  currentStep: number
  didSelectStep: (step: number) => void
  steps: BHStepperStep[]
}

function BHStepper({ currentStep, didSelectStep, steps }: Props) {
  function goToNextStep() {
    if (currentStep < steps.length - 1) {
      didSelectStep(currentStep + 1)
    }
  }

  function goToPreviousStep() {
    if (currentStep > 0) {
      didSelectStep(currentStep - 1)
    }
  }

  const backDisabled = currentStep === 0
  const nextDisabled = currentStep === steps.length - 1

  return (
    <div className="relative min-h-[80vh]">
      <span className="sticky top-1/2 float-right">
        <StepperArrow
          direction="up"
          disabled={backDisabled}
          onClick={goToPreviousStep}
        />
        <StepperArrow
          direction="down"
          disabled={nextDisabled}
          onClick={goToNextStep}
        />
      </span>
      <div className="flex flex-col pr-8 sm:pr-12">
        {steps.map((step, i) => {
          return (
            <StepperHeading
              key={i}
              onClick={() => didSelectStep(i)}
              active={i === currentStep}
              title={step.title}
              subtitle={step.subtitle}
            >
              {step.element}
            </StepperHeading>
          )
        })}
      </div>
    </div>
  )
}

interface StepperArrowProps {
  direction: 'up' | 'down'
  disabled: boolean
  onClick: () => void
}

function StepperArrow({ direction, disabled, onClick }: StepperArrowProps) {
  let arrowChar: JSX.Element
  let translateClass: string

  if (direction === 'up') {
    arrowChar = <>&#8593;</>
    translateClass = '-translate-y-2/3'
  } else {
    arrowChar = <>&#8595;</>
    translateClass = 'translate-y-2/3'
  }

  return (
    <button
      className={`absolute top-1/3 text-xl sm:text-2xl -right-1 sm:-right-2 ${disabled ? 'bg-disabled' : 'bg-bh-red'
        } text-white rounded-lg px-1.5 py-2 sm:p-3 h-12 sm:h-16 ${translateClass}`}
      disabled={disabled}
      onClick={onClick}
    >
      {arrowChar}
    </button>
  )
}

interface StepperHeadingProps {
  onClick: () => void
  active: boolean
  title: string
  subtitle?: string | string[]
  children: React.ReactNode
}
function StepperHeading({
  active,
  onClick,
  title,
  subtitle,
  children,
}: StepperHeadingProps) {
  return (
    <>
      <div
        className="small:flex small:w-full border-b-2 border-b-black pb-1"
        onClick={onClick}
        role="button"
      >
        <h2 className={`font-bold w-full xs:text-sm sm:text-lg small:flex-1 small:font-medium sm:pb-3 sm:pt-3`}>{title}</h2>
        <div className="flex-[2] text-right sm:pt-4 ">
          {subtitle && (
            <BHTagList
              className="justify-end "
              tags={subtitle}
              status="default"
            />
          )}
        </div>
      </div>
      <div
        className={'overflow-auto'}
        style={{
          transition: 'flex-basis 0.3s ease',
          flexBasis: active ? 'auto' : 0,
        }}
      >
        <div className="py-3">
          {children}
        </div>
      </div >
    </>
  )
}

export default BHStepper
